// Shared SweetAlert2 option overrides so confirm/alert popups match the
// site's Blue+Gold theme (see docs/design.md) instead of SweetAlert2's
// stock white/orange/blue defaults. Spread into any Swal.fire() call:
//   Swal.fire({ ...SWAL_THEME, title, text, icon: "warning", ... })
export const SWAL_THEME = {
  background: "linear-gradient(160deg, #0a3680, #062252)",
  color: "#ffffff",
  iconColor: "#f4c430",
  confirmButtonColor: "#d9a520",
  cancelButtonColor: "#0d4bb3",
};
